__webpack_require__.p = "https://dev.lionshare.app/";